import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
} from "@mui/material";

const headerStyle = {
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  padding: "16px 20px",
  borderBottom: "2px solid #000080",
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#bb1ccc !important",
};

const cellStyle = {
  padding: "16px 20px",
  fontSize: "14px",
};

const ProfilingSummaryTable = ({
  rows = [],
  onViewResult = () => {},
  onRunAgain = () => {},
  runningAssets = new Set(),
  containerSx = {},
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        maxHeight: "500px",
        overflow: "auto",
        ...containerSx,
      }}
    >
      <Table sx={{ minWidth: 650 }} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={headerStyle}>Data Asset Name</TableCell>
            <TableCell sx={headerStyle}>Run Status</TableCell>
            <TableCell sx={headerStyle}>View Result</TableCell>
            <TableCell sx={headerStyle}>Run Again</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rows || []).map((row, index) => {
            const statusColor =
              row.status === "Completed"
                ? "#2e7d32"
                : row.status === "Failed"
                ? "#d32f2f"
                : row.status === "In Progress"
                ? "#f57c00"
                : "#6b7280";
            const statusBackground =
              row.status === "Completed"
                ? "#e8f5e8"
                : row.status === "Failed"
                ? "#ffeaea"
                : row.status === "In Progress"
                ? "#fff3e0"
                : "#f3f4f6";
            const isRunning =
              row.status === "In Progress" ||
              row.status === "Pending" ||
              runningAssets.has(row.data_asset_id);

            return (
              <TableRow
                key={row.data_asset_id || index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                  "&:hover": {
                    backgroundColor: "#f0f8ff",
                    transition: "background-color 0.2s ease",
                  },
                }}
              >
                <TableCell
                  sx={{
                    ...cellStyle,
                    fontWeight: 600,
                    color: "#2c3e50",
                  }}
                >
                  {row.data_asset_name || "Unknown"}
                </TableCell>
                <TableCell sx={cellStyle}>
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      px: 2,
                      py: 0.5,
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      backgroundColor: statusBackground,
                      color: statusColor,
                    }}
                  >
                    {row.status || "N/A"}
                  </Box>
                </TableCell>
                <TableCell sx={cellStyle}>
                  <Button
                    variant="text"
                    sx={{
                      color: "#bb1ccc",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "#f0f8ff",
                      },
                      "&:disabled": {
                        color: "#9ca3af",
                        backgroundColor: "transparent",
                      },
                    }}
                    onClick={() =>
                      onViewResult(row.data_asset_id, row.data_asset_name)
                    }
                    disabled={row.status !== "Completed"}
                  >
                    View Result
                  </Button>
                </TableCell>
                <TableCell sx={cellStyle}>
                  <Button
                    variant="text"
                    sx={{
                      color: "#bb1ccc",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "#f0f8ff",
                      },
                      "&:disabled": {
                        color: "#9ca3af",
                        backgroundColor: "transparent",
                      },
                    }}
                    onClick={() => onRunAgain(row.data_asset_id)}
                    disabled={isRunning}
                  >
                    {runningAssets.has(row.data_asset_id)
                      ? "Running..."
                      : "Run Again"}
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
          {!rows?.length && (
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{ ...cellStyle, textAlign: "center", color: "#6b7280" }}
              >
                No data assets found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProfilingSummaryTable;


